<template>

  <section>
    <button v-if="!this.isAuthenticated" class="button is-primary is-small" @click="modal = true">
      Login
    </button>

    <b-modal :active.sync="modal">
      <div @keypress.enter="login()" class="modal-card">
        <div class="modal-card-body">
          <h2>Secure Login.</h2>
        </div>
        <div class="modal-card-body">
          <b-field label="Username">
            <b-input icon="account" type="text" v-model="username"/>
          </b-field>
          <b-field label="Password">
            <b-input icon="lock" type="password" v-model="password"/>
          </b-field>
        </div>
        <div class="modal-card-foot">
          <button class="button is-primary is-small" @click="login()">Login</button>
          <button class="button is-primary is-small" @click="modal = false">Close</button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import Notifications from '@/utils/Notifications'
  import { Snackbar } from 'buefy/dist/components/snackbar'
  import AuthenticationService from "@/service/AuthenticationService"
  import BInput from "buefy/src/components/input/Input";
  import BField from "buefy/src/components/field/Field";
  import BIcon from "buefy/src/components/icon/Icon";
  import BModal from "buefy/src/components/modal/Modal";
  import { mapActions, mapGetters } from 'vuex'
  import { actions } from "@/store/BlogsStore/store";

  export default {
    name: "Login",
    components: {BModal, BIcon, BField, BInput},
    data() {
      return {
        modal: false,
        username: null,
        password: null,
      }
    },
    computed:{
      ...mapGetters(['getUsername','isAuthenticated', 'getToken'])
    },
    methods: {
      ...mapActions(['setToken', 'setUser']),
      login() {
        // AuthenticationService.authenticateJwt(this.getToken);
        this.setToken({'username':this.username, 'password':this.password}).then(()=>{
          this.setUser({'token':this.getToken}).then(()=>{
            actions.setBlogs(this.getToken);
            Snackbar.open(`Logged in as ${this.username}`);
            this.modal = false
          }).catch(()=>{
            Snackbar.open(`Account ${this.username}: Could not retrieve user details`);
          })
        }).catch(()=>{
          Snackbar.open(`Account ${this.username}: Might not exist or you have the incorrect password`);
        })
      }
    }
  }
</script>